export interface YarnColor {
  name: string;
  rgb: [number, number, number];
}

export const yarnColors: YarnColor[] = [
  { name: "Snow Linen", rgb: [250, 250, 250] },
  { name: "Ivory Lace", rgb: [244, 238, 225] },
  { name: "Vintage Parchment", rgb: [236, 228, 210] },
  { name: "Oatmeal Tweed", rgb: [220, 212, 187] },
  { name: "Sand Dune", rgb: [205, 193, 167] },
  { name: "Camel Heather", rgb: [193, 174, 143] },
  { name: "Nutmeg Twist", rgb: [176, 150, 116] },
  { name: "Burnished Copper", rgb: [155, 124, 90] },
  { name: "Autumn Amber", rgb: [191, 129, 76] },
  { name: "Pumpkin Spice", rgb: [212, 119, 52] },
  { name: "Rust Ember", rgb: [168, 80, 27] },
  { name: "Cinnamon Bark", rgb: [140, 63, 22] },
  { name: "Brick Kiln", rgb: [122, 48, 32] },
  { name: "Burgundy Merlot", rgb: [88, 32, 28] },
  { name: "Crushed Cranberry", rgb: [162, 58, 72] },
  { name: "Berry Cordial", rgb: [144, 50, 83] },
  { name: "Rose Quartz", rgb: [228, 173, 188] },
  { name: "Blush Petal", rgb: [239, 207, 216] },
  { name: "Peony Bloom", rgb: [219, 157, 177] },
  { name: "Dusty Rose", rgb: [197, 125, 147] },
  { name: "Antique Mauve", rgb: [167, 105, 126] },
  { name: "Mulberry Silk", rgb: [133, 69, 98] },
  { name: "Plum Wine", rgb: [102, 53, 86] },
  { name: "Deep Fig", rgb: [74, 34, 62] },
  { name: "Lavender Mist", rgb: [215, 204, 232] },
  { name: "Lilac Bloom", rgb: [192, 170, 219] },
  { name: "Violet Frost", rgb: [169, 148, 205] },
  { name: "Iris Petal", rgb: [149, 126, 193] },
  { name: "Amethyst Glow", rgb: [131, 108, 176] },
  { name: "Royal Thistle", rgb: [108, 84, 154] },
  { name: "Aubergine Night", rgb: [74, 53, 107] },
  { name: "Eggplant Shadow", rgb: [56, 40, 83] },
  { name: "Periwinkle Sky", rgb: [180, 188, 236] },
  { name: "Bluebell Whisper", rgb: [155, 167, 222] },
  { name: "Cornflower Wool", rgb: [128, 146, 207] },
  { name: "Royal Cobalt", rgb: [76, 98, 185] },
  { name: "Deep Sapphire", rgb: [44, 75, 159] },
  { name: "Navy Denim", rgb: [33, 54, 118] },
  { name: "Midnight Indigo", rgb: [25, 34, 79] },
  { name: "Blackberry Blue", rgb: [20, 27, 60] },
  { name: "Glacier Mist", rgb: [203, 230, 244] },
  { name: "Arctic Blue", rgb: [174, 212, 233] },
  { name: "Sky Drift", rgb: [147, 194, 221] },
  { name: "Coastal Breeze", rgb: [120, 177, 208] },
  { name: "Ocean Sail", rgb: [99, 161, 194] },
  { name: "Marina Wave", rgb: [77, 142, 179] },
  { name: "Nordic Teal", rgb: [46, 102, 133] },
  { name: "Deep Fjord", rgb: [28, 75, 105] },
  { name: "Seafoam Whisper", rgb: [204, 236, 227] },
  { name: "Mint Frost", rgb: [181, 222, 210] },
  { name: "Wintergreen Wool", rgb: [161, 207, 196] },
  { name: "Jade Essence", rgb: [121, 177, 168] },
  { name: "Verdant Jade", rgb: [96, 156, 146] },
  { name: "Pine Grove", rgb: [62, 109, 100] },
  { name: "Forest Heather", rgb: [44, 89, 81] },
  { name: "Evergreen Shadow", rgb: [31, 68, 62] },
  { name: "Lime Sorbet", rgb: [224, 245, 197] },
  { name: "Pear Zest", rgb: [202, 231, 176] },
  { name: "Apple Leaf", rgb: [178, 212, 152] },
  { name: "Green Meadow", rgb: [151, 181, 121] },
  { name: "Fern Moss", rgb: [126, 158, 100] },
  { name: "Woodland Sprig", rgb: [98, 122, 77] },
  { name: "Olive Grove", rgb: [78, 96, 58] },
  { name: "Dark Herb", rgb: [53, 71, 41] },
  { name: "Lemon Butter", rgb: [253, 246, 188] },
  { name: "Sunbeam Wool", rgb: [245, 233, 155] },
  { name: "Gold Finch", rgb: [235, 221, 128] },
  { name: "Honey Glow", rgb: [217, 199, 104] },
  { name: "Wheatfield", rgb: [199, 175, 71] },
  { name: "Old Gold", rgb: [161, 142, 53] },
  { name: "Ochre Earth", rgb: [130, 113, 40] },
  { name: "Deep Mustard", rgb: [104, 89, 30] },
  { name: "Peach Sorbet", rgb: [255, 214, 190] },
  { name: "Coral Shell", rgb: [248, 181, 157] },
  { name: "Apricot Blush", rgb: [238, 162, 133] },
  { name: "Melon Drift", rgb: [220, 134, 107] },
  { name: "Flamingo Wool", rgb: [202, 99, 82] },
  { name: "Coral Reef", rgb: [176, 71, 61] },
  { name: "Tomato Rust", rgb: [148, 55, 48] },
  { name: "Molten Ember", rgb: [119, 42, 36] },
  { name: "Cloud Grey", rgb: [235, 236, 238] },
  { name: "Silver Gleam", rgb: [218, 219, 221] },
  { name: "Graphite Mist", rgb: [188, 190, 192] },
  { name: "Steel Tweed", rgb: [158, 160, 162] },
  { name: "Charcoal Cloth", rgb: [122, 124, 128] },
  { name: "Shadow Slate", rgb: [92, 94, 98] },
  { name: "Ink Stone", rgb: [58, 60, 63] },
  { name: "Night Black", rgb: [20, 21, 23] },
  { name: "Fawn Wool", rgb: [201, 175, 138] },
  { name: "Caramel Twist", rgb: [178, 148, 101] },
  { name: "Chestnut Roving", rgb: [138, 104, 67] },
  { name: "Walnut Bark", rgb: [98, 73, 48] },
  { name: "Shell Pink", rgb: [247, 208, 215] },
  { name: "Soft Bloom", rgb: [226, 168, 180] },
  { name: "Rose Wool", rgb: [199, 135, 148] },
  { name: "Berry Blush", rgb: [162, 87, 98] },
  { name: "Cherry Twist", rgb: [211, 53, 60] },
  { name: "Crimson Yarn", rgb: [182, 36, 46] },
  { name: "Garnet Wool", rgb: [142, 28, 38] },
  { name: "Deep Ruby", rgb: [102, 19, 27] },
  { name: "Harvest Wool", rgb: [233, 150, 72] },
  { name: "Cider Spice", rgb: [212, 126, 54] },
  { name: "Copper Glow", rgb: [186, 99, 42] },
  { name: "Sienna Heat", rgb: [148, 70, 32] },
  { name: "Wisteria Curl", rgb: [205, 180, 229] },
  { name: "Lavender Wool", rgb: [177, 153, 209] },
  { name: "Royal Plum", rgb: [125, 96, 164] },
  { name: "Nightshade", rgb: [74, 52, 113] }
];

// Find the nearest yarn color name for a given hex color string.
export function findNearestYarnName(hex: string){
  function hexToRgb(h: string){
    const s = h.replace('#','');
    const v = s.length === 3 ? s.split('').map(c=>c+c).join('') : s;
    const r = parseInt(v.slice(0,2),16); const g = parseInt(v.slice(2,4),16); const b = parseInt(v.slice(4,6),16);
    return [r,g,b];
  }
  const target = hexToRgb(hex);
  // helper: chroma (max-min) indicates how saturated/tinted a color is
  const chroma = (c: [number,number,number]) => Math.max(c[0],c[1],c[2]) - Math.min(c[0],c[1],c[2]);
  const lum = (c: [number,number,number]) => 0.299 * c[0] + 0.587 * c[1] + 0.114 * c[2];

  // If the color is near-grayscale (low chroma), prefer names from the neutral/grayscale subset
  const targetChroma = chroma(target as [number,number,number]);
  if(targetChroma <= 12){
    const candidates = yarnColors.filter(yc => chroma(yc.rgb as [number,number,number]) <= 18);
    if(candidates.length){
      let best = candidates[0].name;
      let bestDiff = Infinity;
      const tL = lum(target as [number,number,number]);
      for(const c of candidates){
        const d = Math.abs(lum(c.rgb as [number,number,number]) - tL);
        if(d < bestDiff){ bestDiff = d; best = c.name; }
      }
      return best;
    }
  }

  // otherwise fall back to nearest in RGB space
  let bestName = yarnColors[0]?.name || 'Color';
  let bestD = Infinity;
  for(const yc of yarnColors){
    const [r,g,b] = yc.rgb;
    const dr = r - target[0], dg = g - target[1], db = b - target[2];
    const d = dr*dr + dg*dg + db*db;
    if(d < bestD){ bestD = d; bestName = yc.name; }
  }
  return bestName;
}
